// Прихоти дизайна (меняет дефис на тире)

const HYPHEN_WITH_SPACE = /\s-/;
const DASH_WITH_SPACE = /\s—/;
const DASH_OR_HYPHEN_WITH_SPACE = /\s(—|-)/;

export function replacingHyphenOnDash(value?: string): string {
  return value ? value.replace(HYPHEN_WITH_SPACE, '\xa0—') : '';
}

export function replacingDashOnHyphen(value?: string): string {
  return value ? value.replace(DASH_WITH_SPACE, ' -') : '';
}

export function replaceDividerOnDash(value?: string): string {
  return value ? value.replace(DASH_OR_HYPHEN_WITH_SPACE, '\xa0—') : '';
}
